// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useMemo, useState } from "react";
import Keycloak from "keycloak-js";
var authSessions = new Map();
var getAuthSession = function (sessionKey, settings, realm) {
    var existing = authSessions.get(sessionKey);
    if (existing) {
        return existing;
    }
    var session = {
        keycloak: new Keycloak({
            url: settings.KEYCLOAK_URL,
            realm: realm,
            clientId: settings.RESULTS_PORTAL_CLIENT_ID,
        }),
    };
    authSessions.set(sessionKey, session);
    return session;
};
var tokenClaim = function (keycloak, name) {
    var _a;
    var value = (_a = keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a[name];
    return typeof value === "string" && value ? value : undefined;
};
var openAccountManagement = function (keycloak) {
    void keycloak.accountManagement();
};
var userProfileFromClaims = function (keycloak) {
    var _a, _b, _c, _d;
    return ({
        firstName: (_a = tokenClaim(keycloak, "given_name")) !== null && _a !== void 0 ? _a : tokenClaim(keycloak, "name"),
        username: (_d = (_c = (_b = tokenClaim(keycloak, "preferred_username")) !== null && _b !== void 0 ? _b : tokenClaim(keycloak, "email")) !== null && _c !== void 0 ? _c : tokenClaim(keycloak, "sub")) !== null && _d !== void 0 ? _d : "user",
        email: tokenClaim(keycloak, "email"),
        openLink: function () { return openAccountManagement(keycloak); },
    });
};
var userProfileFromKeycloak = function (profile, keycloak) {
    var _a, _b, _c, _d;
    var fallbackProfile = userProfileFromClaims(keycloak);
    return {
        firstName: (_a = profile.firstName) !== null && _a !== void 0 ? _a : fallbackProfile.firstName,
        username: (_c = (_b = profile.username) !== null && _b !== void 0 ? _b : profile.email) !== null && _c !== void 0 ? _c : fallbackProfile.username,
        email: (_d = profile.email) !== null && _d !== void 0 ? _d : fallbackProfile.email,
        openLink: fallbackProfile.openLink,
    };
};
var loadUserProfile = function (keycloak) { return __awaiter(void 0, void 0, Promise, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                _a = userProfileFromKeycloak;
                return [4 /*yield*/, keycloak.loadUserProfile()];
            case 1: return [2 /*return*/, _a.apply(void 0, [_c.sent(), keycloak])];
            case 2:
                _b = _c.sent();
                return [2 /*return*/, userProfileFromClaims(keycloak)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var logoutSession = function (keycloak) {
    void keycloak.logout({
        redirectUri: window.location.href.split("#")[0],
    });
};
var authStateFromSession = function (session) { return __awaiter(void 0, void 0, Promise, function () {
    var token, _a, _b;
    var _c;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                token = session.keycloak.token;
                if (!token) {
                    return [2 /*return*/, {
                            loading: false,
                        }];
                }
                _c = {
                    loading: false,
                    token: token
                };
                if (!((_d = session.userProfile) !== null && _d !== void 0)) return [3 /*break*/, 1];
                _a = _d;
                return [3 /*break*/, 3];
            case 1:
                _b = session;
                return [4 /*yield*/, loadUserProfile(session.keycloak)];
            case 2:
                _a = (_b.userProfile = _e.sent());
                _e.label = 3;
            case 3: return [2 /*return*/, (_c.userProfile = _a,
                    _c.logout = function () { return logoutSession(session.keycloak); },
                    _c)];
        }
    });
}); };
var authenticateSession = function (sessionKey, session) { return __awaiter(void 0, void 0, Promise, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!session.initPromise) {
                    session.initPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                        var authenticated;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, session.keycloak.init({
                                        onLoad: "login-required",
                                        checkLoginIframe: false,
                                        flow: "standard",
                                        responseMode: "fragment",
                                        redirectUri: window.location.href.split("#")[0],
                                    })];
                                case 1:
                                    authenticated = _a.sent();
                                    if (!authenticated || !session.keycloak.token) {
                                        throw new Error("Authentication failed");
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })();
                }
                return [4 /*yield*/, session.initPromise];
            case 1:
                _a.sent();
                return [4 /*yield*/, session.keycloak.updateToken(30)];
            case 2:
                _a.sent();
                return [2 /*return*/, authStateFromSession(session)];
            case 3:
                error_1 = _a.sent();
                if (authSessions.get(sessionKey) === session) {
                    authSessions.delete(sessionKey);
                }
                return [2 /*return*/, {
                        loading: false,
                        error: error_1 instanceof Error ? error_1.message : "Authentication failed",
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var sessionTokenState = function (sessionKey) {
    var session = sessionKey ? authSessions.get(sessionKey) : undefined;
    var token = session === null || session === void 0 ? void 0 : session.keycloak.token;
    return {
        loading: false,
        token: token,
        logout: session ? function () { return logoutSession(session.keycloak); } : undefined,
    };
};
export var useAuthenticatedResults = function (settings, tenantId, eventId, required) {
    if (required === void 0) { required = false; }
    var _a = useState({ loading: required }), state = _a[0], setState = _a[1];
    var realm = useMemo(function () { return (tenantId && eventId ? "tenant-".concat(tenantId, "-event-").concat(eventId) : undefined); }, [tenantId, eventId]);
    useEffect(function () {
        var sessionKey = realm
            ? [settings.KEYCLOAK_URL, realm, settings.RESULTS_PORTAL_CLIENT_ID].join("|")
            : undefined;
        if (!required) {
            setState(sessionTokenState(sessionKey));
            return;
        }
        if (!realm || !sessionKey) {
            setState({ loading: true });
            return;
        }
        var mounted = true;
        var session = getAuthSession(sessionKey, settings, realm);
        var refreshInterval;
        var updateStateFromSession = function () { return __awaiter(void 0, void 0, void 0, function () {
            var nextState, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, session.keycloak.updateToken(60)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, authStateFromSession(session)];
                    case 2:
                        nextState = _a.sent();
                        if (mounted) {
                            setState(nextState);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (authSessions.get(sessionKey) === session) {
                            authSessions.delete(sessionKey);
                        }
                        if (mounted) {
                            setState({
                                loading: false,
                                error: error_2 instanceof Error ? error_2.message : "Authentication failed",
                            });
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var init = function () { return __awaiter(void 0, void 0, void 0, function () {
            var nextState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setState({ loading: true });
                        return [4 /*yield*/, authenticateSession(sessionKey, session)];
                    case 1:
                        nextState = _a.sent();
                        if (mounted) {
                            setState(nextState);
                            if (nextState.token) {
                                session.keycloak.onTokenExpired = function () {
                                    void updateStateFromSession();
                                };
                                refreshInterval = window.setInterval(function () {
                                    void updateStateFromSession();
                                }, 30000);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void init();
        return function () {
            mounted = false;
            if (refreshInterval !== undefined) {
                window.clearInterval(refreshInterval);
            }
            session.keycloak.onTokenExpired = undefined;
        };
    }, [required, realm, settings.KEYCLOAK_URL, settings.RESULTS_PORTAL_CLIENT_ID]);
    return state;
};
